import DICOMMediaRenderer from 'libs/dicom-media-renderer';

export default function(params) {
  const self = this;

  self.id = params['id'];
  self.node = params['node'].querySelector('.js-dicom-image');
  self.src = params['src'];

  self.init = () => {
    let $mediaArea = $('.js-coursework-view__media-area');
    self.renderer = new DICOMMediaRenderer({ src: self.src, $container: $mediaArea });
    self.renderer.present(() => {
      self.renderer.$viewer = $(self.node);
      $(self.node).css('height', $mediaArea.height());
    });
  };

  self.init();

  return self;
}

